<template>
  <paywall-modal
    :feature-type="FEATURE_TYPE.INTEGER"
    :heading="heading"
    :show="show"
    @input="closeModal"
  >
    <div slot="content">
      <div>
        <span v-if="maxUserCount"
          >Your current plan allows you <b>{{ maxUserCount }} users.</b></span
        >
        To invite more, remove users or cancel invites you have already sent or remove existing
        users
      </div>
    </div>
  </paywall-modal>
</template>

<script>
import { trackAnalyticsEvent } from '@/analytics'
import PaywallModal from '@/components/paywalls/PaywallModal.vue'
import { EVENT_ACTION, EVENT_CATEGORY } from '@/constants/analytics'
import { FEATURE_TYPE, featureFlags } from '@/constants/featureFlags'
import BillingMixin from '@/mixins/BillingMixin'
import FeaturesMixin from '@/mixins/FeaturesMixin'
import getPlanDisplayName from '@/utils/getPlanDisplayName'

/**
 * This is the modal that gets shown when user is trying to add more users than allowed limit
 */
export default {
  name: 'MaxUsersPaywallModal',
  props: ['orgId', 'show'],
  model: {
    prop: 'show'
  },
  components: {
    PaywallModal
  },
  data() {
    return {
      isPaywallModalShown: false,
      subscription: null,
      FEATURE_TYPE
    }
  },
  mixins: [FeaturesMixin, BillingMixin],
  computed: {
    maxUserCount() {
      return this.getFeatureFlagValue(this.orgId, featureFlags.MAX_USER_COUNT)
    },
    heading() {
      return (
        'You’ve reached the limit of Users' +
        (this.subscription ? ` in the ${getPlanDisplayName(this.subscription.name)}` : '')
      )
    }
  },
  methods: {
    getPlanDisplayName,
    closeModal() {
      this.$emit('input', false)
    }
  },
  async mounted() {
    this.subscription = await this.fetchActiveSubscription(this.orgId)
    trackAnalyticsEvent(EVENT_CATEGORY.UPGRADES, EVENT_ACTION.PAYWALL_CLICKED, {
      paywall: 'Users limit'
    })
  }
}
</script>

<style lang="scss" scoped></style>
